import { Controller } from "@hotwired/stimulus"

// "Run Autobot" — triggers a REAL run (POST /autobot/trigger_run →
// AutobotRunnerJob), which discovers + submits applications. Lives on the
// dashboard wrapper so it works on both /app/autobot and the legacy
// /users/edit AI Copilot tab. (The shared header button was previously bound
// to profile-edit#runTestRun — a dry test — whose controller is NOT present on
// the extracted /app/autobot page, so the click was a no-op.)
export default class extends Controller {
  static targets = ["status"]

  async run(event) {
    if (event) event.preventDefault()
    const button = event.currentTarget
    // Real outward action (submits applications in the user's name) — confirm.
    if (!window.confirm("Run the autobot now? It will apply to matching jobs in your name.")) return

    const original = button.innerHTML
    button.disabled = true
    button.innerHTML = "Running…"
    this._notify("Starting your autobot run…")

    try {
      const res = await fetch("/autobot/trigger_run", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })
      const data = await res.json().catch(() => ({}))
      // data can be null (a literal `null` JSON body parses to null), so use
      // optional chaining — data.error on null would throw.
      if (res.ok && data?.success) {
        this._notify(data?.message || "Autobot run triggered. Applications will appear in your activity feed shortly.")
      } else {
        this._notify(data?.error || "Couldn't start the autobot run. Please try again.", true)
      }
    } catch (e) {
      this._notify("Network error — please try again.", true)
    } finally {
      button.disabled = false
      button.innerHTML = original
    }
  }

  // Enable/disable the autobot. Same dead-controller fix as the run button: the
  // toggle was bound to profile-edit#toggleAutobot, which isn't present on
  // /app/autobot. POSTs /autobot/update_status; reverts the checkbox on failure.
  async toggle(event) {
    const checkbox = event.target
    const enabled = checkbox.checked
    try {
      const res = await fetch("/autobot/update_status", {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ enabled })
      })
      const data = await res.json().catch(() => ({}))
      if (res.ok && data?.success) {
        this._notify(enabled ? "Autobot enabled." : "Autobot paused.")
      } else {
        checkbox.checked = !enabled // revert on failure
        this._notify(data?.error || "Couldn't update autobot status. Please try again.", true)
      }
    } catch (e) {
      checkbox.checked = !enabled
      this._notify("Network error — couldn't update autobot status.", true)
    }
  }

  _notify(message, isError = false) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.hidden = false
      this.statusTarget.classList.toggle("text-error", isError)
      this.statusTarget.classList.toggle("text-on-surface-variant", !isError)
    } else {
      window.alert(message)
    }
  }
}
